import { Icon24Dismiss } from "@vkontakte/icons";
import s from "./style.module.scss";
import { usePopout } from "../../core/reatom/state/popout/popout";

interface FullImageVieweProps {
  name?: string;
  url?: string;
}

export const FullImageViewer = ({ name, url }: FullImageVieweProps) => {
  const { hide } = usePopout();

  return (
    <div className={s.fullImageViewer}>
      <button className={s.fullImageViewer_close} onClick={() => hide()}>
        <Icon24Dismiss />
      </button>
      <img src={url} alt={name} />
    </div>
  );
};
